export class CallerConst {
  static readonly MESSAGES = 'messages';

  static readonly PLAN = 'plan';

  static readonly MY_PLAN = 'my-plan';

  static readonly PLANNING_VIEW = 'planning-view';

  static readonly PLANNING_EDIT = 'planning-edit';

  static readonly EMPLOYEES = 'employees';

  static readonly ADMINISTRATION = 'administration';
}
